import { Box } from "@chakra-ui/react";
import React from "react";
 

const BackgroundHills = () => {
    return (
        <Box
        position="fixed"
        top={0}
        left={0}
        right={0}
        bottom={0}
        overflow="hidden"
        pointerEvents="none"
        zIndex={-2}
        bg="linear-gradient(135deg, #104547 -25.92%, #165F62 35.61%, #357E81 65.95%, #7BC9CC 93.64%)"
      >
        {/* Marketing gradient background */}
      </Box>
    );
}

export default BackgroundHills;